import styled from "styled-components";
import { Section } from "./../../styled/index";

export const ExperienceStyled = styled(Section)``;
